module.exports = __webpack_public_path__ + "static/media/js.8c44d07b.png";